document.addEventListener('DOMContentLoaded', function() {
  const sizeSelector = document.getElementById('sizeSelector');
  const productOptions = document.getElementById('productOptions');

  if (sizeSelector) {
    sizeSelector.addEventListener('change', function() {
      const selectedSize = sizeSelector.value;

      if (selectedSize) {
        fetchProductDetails(selectedSize);
      } else {
        productOptions.innerHTML = '';
      }
    });
  }

  function fetchProductDetails(size) {
    let productId;
    // Use the metafield values to determine the product ID for the selected size
    switch (size) {
      case 'small':
        productId = '{{ product.metafields.custom.small_product_id.value }}';
        break;
      case 'medium':
        productId = '{{ product.metafields.custom.medium_product_id.value }}';
        break;
      case 'tapered':
        productId = '{{ product.metafields.custom.tapered_product_id.value }}';
        break;
      default:
        productId = '';
    }

    if (productId) {
      productId=8757491532022;
      console.log("productId",productId);
      fetch(`/products/${productId}.js`)
        .then(response => response.json())
        .then(data => displayProductOptions(data))
        .catch(error => console.error('Error fetching product details:', error));
    }
  }

  function displayProductOptions(product) {
    let html = `<h2>${product.title}</h2>`;
    html += `<p>${product.description}</p>`;

    product.variants.forEach(variant => {
      html += `
        <div>
          <input type="radio" name="variant" value="${variant.id}" id="variant_${variant.id}">
          <label for="variant_${variant.id}">${variant.title} - ${variant.price / 100} ${Shopify.currency.active}</label>
        </div>
      `;
    });

    if (productOptions) {
      productOptions.innerHTML = html;
    } else {
      console.error('Product options container not found.');
    }
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const tabs = document.querySelectorAll('.tab-link');
  const sections = document.querySelectorAll('.tab-section');

  tabs.forEach(tab => {
    tab.addEventListener('click', function(event) {
      event.preventDefault();
      
      const target = tab.getAttribute('data-target');

      // Hide all sections
      sections.forEach(section => {
        section.classList.add('hidden');
      });

      // Remove active class from all tabs
      tabs.forEach(t => {
        t.classList.remove('active');
      });

      // Show the target section
      document.querySelector(`#${target}`).classList.remove('hidden');

      // Add active class to the clicked tab
      tab.classList.add('active');
    });
  });


});



